import React, { useEffect, useState, useRef } from "react";
import classNames from 'classnames';
import styles from "./VerticalLabel.module.scss";

export interface VerticalLabelProps {
  label: JSX.Element;
  value: JSX.Element | string | number;
  sizeLabel?: number;  // 🟢 Modifié pour être un pourcentage (nombre)
  sizeValue?: number;  // 🟢 Modifié pour être un pourcentage (nombre)
  colorLabel?: string;
  colorValue?: string;
  width?: string;
  onMouseEnter?:  (event: React.MouseEvent) => void;
  onMouseLeave?:  (event: React.MouseEvent) => void;
}

const VerticalLabel: React.FC<VerticalLabelProps> = ({
  label,
  value,
  sizeLabel = 12, // 🟢 Valeur par défaut pour sizeLabel en pourcentage (12%)
  sizeValue = 15, // 🟢 Valeur par défaut pour sizeValue en pourcentage (15%)
  colorLabel = "var(--color-Text-FG-normal)",
  colorValue = "var(--color-Text-FG-emphasized)",
  width = "auto",
  onMouseEnter,
  onMouseLeave
}) => {

  const rootRef = useRef<HTMLDivElement | null>(null);
  const [rootWidth, setRootWidth] = useState(100);
  const [ready, setReady] = useState(false);

  useEffect(() => {

    const updateWidth = () => {
      if (rootRef.current) {
        const newWidth = rootRef.current.clientWidth;
        setRootWidth(newWidth);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    if (rootRef.current) {
      resizeObserver.observe(rootRef.current);
      updateWidth();
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (rootRef.current) {
      setRootWidth(rootRef.current.clientWidth);
      setReady(true);
    }
  }, [rootRef.current]);

  // Calcul des tailles des polices basées sur rootWidth
  const labelFontSize = rootWidth * (sizeLabel / 100);
  const valueFontSize = rootWidth * (sizeValue / 100);

  return (
    <div ref={rootRef} className={styles.root} style={{ width }}>
      {ready && (
        <>
          <div
            className={classNames(styles.label)}
            style={{ color: colorLabel, fontSize: `${labelFontSize}px` }}
          >
            {label}
          </div>
          <div
            className={classNames(styles.value)}
            style={{ color: colorValue, fontSize: `${valueFontSize}px` }}
onMouseEnter={(e) => onMouseEnter?.(e)}
onMouseLeave={(e) => onMouseLeave?.(e)}>
            {value}
          </div>
        </>
      )}
    </div>
  );
};

export default VerticalLabel;
